import { ButtonHTMLAttributes } from 'react';
import styles from './PolicyMetaButton.module.css';

export interface PolicyMetaButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	variant?: 'version' | 'date';
}

export const PolicyMetaButton = ({
	children,
	variant = 'version',
	className,
	...props
}: PolicyMetaButtonProps) => {
	return (
		<button className={`${styles.button} ${styles[variant]} ${className || ''}`} {...props}>
			<span className={styles.text}>{children}</span>
		</button>
	);
};
